export const paymentHistoryCreditScore = (payHistory) => {
    /**
     * Calculates a payment history score (0–35)
     * Adds realistic penalties for recent late payments
     */

    // Sort by date ASC (oldest → newest)
    const sorted = payHistory.slice().sort((a, b) => a.month.localeCompare(b.month));
    //const N = sorted.length;

    // Linear recency weights: 1..N
    const weights = sorted.map((_, i) => i + 1);
    const totalWeight = weights.reduce((a, b) => a + b, 0);

    const STATUS_SCORE = {
        onTime: 1.0,
        paidLate: 0.4,
        unpaid: 0.0
    };

    let weightedSum = 0;

    sorted.forEach((item, idx) => {
        let baseScore = STATUS_SCORE[item.payStatus] ?? 0;

        if (item.payStatus === "onTime" && item.amtApplied < item.minPayAmt) {
            baseScore = 0.4;
        }
        if (item.amtApplied === 0) {
            baseScore = 0.0;
        }

        weightedSum += baseScore * weights[idx];
    });

    // Base normalized score (0–1)
    let normalized = weightedSum / totalWeight;

    /* -------------------------------
       RECENT DELINQUENCY ADJUSTMENTS
       ------------------------------- */

    // Look at the most recent 6 months
    const recentMonths = sorted.slice(-6);

    const recentLateCount = recentMonths.filter(
        m => m.payStatus === "paidLate" || m.payStatus === "unpaid"
    ).length;

    const recentUnpaidCount = recentMonths.filter(
        m => m.payStatus === "unpaid"
    ).length;

    // Apply nonlinear penalties
    if (recentLateCount >= 1) normalized *= 0.85;   // first recent late hurts a lot
    if (recentLateCount >= 2) normalized *= 0.75;   // pattern of late payments
    if (recentUnpaidCount >= 1) normalized *= 0.60; // very serious delinquency

    // Hard cap: cannot be "excellent" with recent lates
    let score = Math.round(normalized * 35);

    if (recentLateCount >= 2) {
        score = Math.min(score, 22); // ~63% of 35
    }

    if (recentUnpaidCount >= 1) {
        score = Math.min(score, 18);
    }

    return Math.max(0, score);
};

export default paymentHistoryCreditScore;
